import React, { Component } from 'react';
import moment from 'moment';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Paper from '@material-ui/core/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AppBar from '@material-ui/core/AppBar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div p={3}>
            {children}
          </div>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

class AppMetricsPanel extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      tabValue: 0,
      hasData: false
    };
  }

  componentDidUpdate(prevProps)
  {
    const hasData = (this.props.appMetricsPackage);

    if (hasData !== this.state.hasData)
    {
      this.setState({
        hasData: hasData
      });
    }
  }

  handleTabChange = (event, newValue) =>
  {
    this.setState({
      tabValue: newValue
    });
  };

  onClose = () => {
    
    this.setState({
      dataLoaded: false,
      canSearch: false,
      searchIdentifer: null,
      searchValue: '',
      showEditInfo: false,
      editInfoPackage: null
    });

    this.props.onClose();
  }

  onUserAction(value) 
  {
    const searchEnabled = this.state.searchIdentifer !== null && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  updateSearchValue = (value) => {
    const searchEnabled = (this.state.searchIdentifer !== null && this.state.searchIdentifer !== '') && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
}

  searchIncident = () => {
    window.api.searchAdminIncident(this.state.searchValue, this.state.searchIdentifer).then((response) => 
    {
      this.setState({
        showEditInfo: true,
        editInfoPackage: response
      });
    });
  }

  getContent = () => {
    return (this.state.hasData) ? (<div>
    <TabPanel value={this.state.tabValue} index={0} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
      <TableBody style={{width: "600px"}}>
            <TableRow>
                <TableCell>Total InFORM Users:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TotalUserCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Distinct User Logins (past 24 hrs)</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TodayDistinctUserLogins.toLocaleString()}</TableCell>
            </TableRow>
        </TableBody>
        </Table>
    </TabPanel>
    <TabPanel value={this.state.tabValue} index={1} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
        <TableBody>
            <TableRow>
                <TableCell>Last Irwin check:</TableCell>
                <TableCell align="right">{moment(this.props.appMetricsPackage.IrwinMetrics.LastIrwinSync).format("MM/DD/YYYY h:mm A")}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Most recent Irwin Create Date:</TableCell>
                <TableCell align="right">{moment(this.props.appMetricsPackage.IrwinMetrics.NewestIrwinCreateDate).format("MM/DD/YYYY h:mm A")}</TableCell>
            </TableRow>
        </TableBody>
      </Table>

    </TabPanel>
    <TabPanel value={this.state.tabValue} index={2} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
      <TableBody style={{width: "600px"}}>
            <TableRow>
                <TableCell>Spatial Queue:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.QueueMetrics.SpatialServiceQueueCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Deriviation Queue:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.QueueMetrics.DerivationServiceQueueCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Uniqueness Queue:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.QueueMetrics.UniquenessServiceQueueCount.toLocaleString()}</TableCell>
            </TableRow>
            </TableBody>
        </Table>
    </TabPanel>
    <TabPanel value={this.state.tabValue} index={3} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
      <TableBody style={{width: "600px"}}>
          <TableRow>
                <TableCell>Average View time:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.AverageMetrics.AverageViewInSeconds.toFixed(2)} seconds</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Average Edit time:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.AverageMetrics.AverageEditInSeconds.toFixed(2)} seconds</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Certified records (past 24 hrs)</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TodayCertifiedCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>De-certified records (past 24 hrs)</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TodayDecertifiedCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Incidents viewed (past 24 hrs)</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TodayViewCount.toLocaleString()}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Incidents edited (past 24 hrs)</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.CountMetrics.TodayEditCount.toLocaleString()}</TableCell>
            </TableRow>
            
            <TableRow>
                <TableCell>Total number of perimeters edits:</TableCell>
                <TableCell align="right">12</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Average edits per edited incident:</TableCell>
                <TableCell align="right">{this.props.appMetricsPackage.AverageMetrics.AverageEditsPerEditedIncident.toLocaleString()}</TableCell>
            </TableRow>
            </TableBody>
        </Table>
    </TabPanel>
    <TabPanel value={this.state.tabValue} index={4} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
      <TableBody style={{width: "600px"}}>
            <TableRow>
                <TableCell>Summaries Reporting:</TableCell>
                <TableCell align="right">62</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Uniqueness Score views:</TableCell>
                <TableCell align="right">15</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Measure Tool:</TableCell>
                <TableCell align="right">3</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Report view:</TableCell>
                <TableCell align="right">9</TableCell>
            </TableRow>
            </TableBody>
        </Table>
    </TabPanel>  
    <TabPanel value={this.state.tabValue} index={5} style={{padding: "5px 5px 5px 5px"}}>
    <Table aria-label="simple table"  style={{width: "600px"}}>
      <TableBody style={{width: "600px"}}>
            <TableRow>
                <TableCell>Point of Origin:</TableCell>
                <TableCell align="right">7</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Protecting Unit:</TableCell>
                <TableCell align="right">15</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Jurisdictional Unit:</TableCell>
                <TableCell align="right">7</TableCell>
            </TableRow>
            </TableBody>
        </Table>
    </TabPanel>  
  </div>
    ) : 
    (<CircularProgress size={24} thickness={2} style={{padding: "5px 5px 5px 5px"}} />);
  }
  updateIdentifier = (value) => {

    const searchEnabled = (this.state.searchValue !== null && this.state.searchValue !== '') && value !== null;
    this.setState({
      searchIdentifer: value,
      canSearch: searchEnabled
    });
  }

  render() {
    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={this.onClose}
      />
    ];

    return (
      <Dialog
        open={this.props.open}
        modal={true}
        actions={actions}
        autoScrollBodyContent={true}
        contentStyle={{ width: '700px', height: '70%', maxWidth: 'none', overflowy: 'auto' }}>
        <Paper>
          <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                App Metrics
              </Typography>
            </Toolbar>
            
          </AppBar>
           <div>
           <Tabs value={this.state.tabValue} onChange={this.handleTabChange}  aria-label="Tabs">
            <Tab label="Users" {...a11yProps(0)} />
            <Tab label="Irwin" {...a11yProps(1)} />
            <Tab label="Services" {...a11yProps(2)} />
            <Tab label="Incidents" {...a11yProps(3)} />
            <Tab label="Tool Usage" {...a11yProps(4)} />
            <Tab label="Attribute Edits" {...a11yProps(5)} />
         </Tabs>
            {this.getContent()}
          </div>
        </Paper>
      </Dialog>
    );
  }
}
export default AppMetricsPanel;
